import React, { useState } from 'react';
import { Lock, Loader2 } from 'lucide-react';
import { changePasswordRequest } from '../lib/accountService';

export default function ChangePasswordPage({ apiUrl, user, onChanged, onLogout }) {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [again, setAgain] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const submit = async (event) => {
    event.preventDefault();
    setError('');
    if (next !== again) {
      setError('The two new passwords do not match');
      return;
    }
    setLoading(true);
    try {
      const data = await changePasswordRequest(apiUrl, current, next);
      onChanged(data.token, data.user);
    } catch (err) {
      const msg = err.response?.data?.detail || err.message || 'Could not change the password';
      setError(typeof msg === 'string' ? msg : 'Could not change the password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page executive-app">
      <div className="login-shell">
        <div className="login-panels">
          <div className="login-card" style={{ margin: '0 auto' }}>
            <div className="login-brand">
              <h1>Set a new password</h1>
              <p>
                {user?.must_change_password
                  ? 'Choose your own password before you continue.'
                  : 'Choose a new password.'}
              </p>
            </div>
            <form className="login-form" onSubmit={submit} data-testid="change-password-form">
              <label className="login-field">
                <span>Current password</span>
                <div className="login-input-wrap">
                  <Lock size={18} />
                  <input type="password" autoComplete="current-password" value={current}
                    onChange={(e) => setCurrent(e.target.value)} required data-testid="cp-current" />
                </div>
              </label>
              <label className="login-field">
                <span>New password (at least 10 characters)</span>
                <div className="login-input-wrap">
                  <Lock size={18} />
                  <input type="password" autoComplete="new-password" value={next}
                    onChange={(e) => setNext(e.target.value)} required minLength={10} data-testid="cp-new" />
                </div>
              </label>
              <label className="login-field">
                <span>Repeat new password</span>
                <div className="login-input-wrap">
                  <Lock size={18} />
                  <input type="password" autoComplete="new-password" value={again}
                    onChange={(e) => setAgain(e.target.value)} required data-testid="cp-again" />
                </div>
              </label>
              {error ? <div className="login-error" role="alert">{error}</div> : null}
              <button type="submit" className="login-submit" disabled={loading} data-testid="cp-submit">
                {loading ? <Loader2 size={18} className="login-spinner" /> : null}
                {loading ? 'Saving…' : 'Save and continue'}
              </button>
              <button type="button" className="login-submit" style={{ background: 'transparent', color: 'inherit', boxShadow: 'none' }}
                onClick={onLogout}>
                Sign out
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
